export const ADD_TAKEAWAY_REQUEST = " ADD_TAKEAWAY_REQUEST";
export const ADD_TAKEAWAY_SUCCESS = " ADD_TAKEAWAY_SUCCESS";
export const ADD_TAKEAWAY_FAILURE = " ADD_TAKEAWAY_FAILURE";
